// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckoutCancel_wrapper__tW+n6","button":"CheckoutCancel_button__hg2Zf","icon":"CheckoutCancel_icon__DHtAe"};